/* @ngInject */
function employeeCheckInterceptor($window) {
  /**
   * @param {string} url
   * @returns {boolean}
   */
  const isValidUrl = (url) => {
    const baseUrl = process.env.EMPLOYEE_CHECK_API;
    return url.includes(baseUrl);
  };

  /**
   * @param {Object} request
   */
  const addAuthToken = (request) => {
    const username = process.env.EMPLOYEE_CHECK_BASIC_AUTH_USERNAME;
    const password = process.env.EMPLOYEE_CHECK_BASIC_AUTH_PASSWORD;
    const basicAuth = `Basic ${$window.btoa(`${username}:${password}`)}`;

    request.headers.Authorization = basicAuth;
  };

  return {
    request(requestConfig) {
      if (isValidUrl(requestConfig.url)) {
        addAuthToken(requestConfig);
      }

      return requestConfig;
    }
  };
}

export default employeeCheckInterceptor;
